import { render, staticRenderFns } from "./educator-column.vue?vue&type=template&id=7661c21c&scoped=true&"
import script from "./educator-column.vue?vue&type=script&lang=js&"
export * from "./educator-column.vue?vue&type=script&lang=js&"
import style0 from "./educator-column.vue?vue&type=style&index=0&id=7661c21c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7661c21c",
  null
  
)

export default component.exports